module.exports = {
  blogPostDir: "posts", // The name of directory that contains your posts.
  siteTitle: "Laina-apu", // Site title.
  siteTitleAlt: "Laina-apu - Apua laina-asioihin.", // Alternative site title for SEO.
  siteLogo: "/logos/logo-1024.png", // Logo used for SEO and manifest.
  siteUrl: "https://laina-apu.fi", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Löydä apua laina-asioihin helposti verkosta.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "1643885662309715", // FB Application ID for using app insights
  googleAnalyticsID: "UA-84754305-6", // GA tracking ID.
  postDefaultCategoryID: "Blogi", // Default category for posts.
  userName: "Laina-apu", // Username to display in the author segment.
  userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Helsinki, Finland", // User location to display in the author segment.
  userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
  userDescription:
    "Laina-apu auttaa laina-asioissa kertomalla lisätietoja siitä, mistä ja miten hakea lainaa onnistuneesti.", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "Email",
      url: "mailto:info@laina-apu.fi",
      iconClassName: "fa fa-envelope"
    }
  ],
  copyright: "Copyright © 2017. Laina-apu", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#388E2D", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js